<template>
  <BaseSkeleton
    v-if="isLoading"
    type="button"
    :class="classes"
    v-bind="$attrs"
  />
  <VBtnAdapted
    v-else
    depressed
    class="base-button"
    :class="classes"
    :disabled="disabled ? 'disabled' : null"
    v-bind="$attrs"
  >
    <slot />
  </VBtnAdapted>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';
import BaseSkeleton from '@/shared/lib/uikit/components/BaseSkeleton/BaseSkeleton.vue';
import VBtnAdapted from '@/shared/components/v3Adopted/VBtnAdapted.vue';

export default defineComponent({
  name: 'BaseButton',
  components: { VBtnAdapted, BaseSkeleton },
  extends: BaseComponent,
});
</script>

<style lang="scss" scoped>
body .v-btn.base-button {
  box-shadow: none;
  &.variant {
    &__ghost {
      background: transparent;
      border: none
    }
  }

  &.m {
    &_width-full {
      width: 100%;
    }

    &_color-accent-block {
      :deep(.v-btn__content) {
        color: var(--blockAccentFont)
      }
    }
  }
}

@if mixin-exists("ThemeBaseButton") {
  @include ThemeBaseButton;
}
</style>
